import Img from '../components/Img';
import React from 'react';
import './OurTechnology.css';
import { Helmet } from '@dr.pogodin/react-helmet';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';

const OurTechnology: React.FC = () => {
  return (
    <>
    <Helmet>
      <title>Our Technology | Atomic Tattoo Removal</title>
      <meta name="description" content="Discover the advanced laser technology we use for safe and effective tattoo removal at Atomic Tattoo Removal." />
      <meta name="keywords" content="tattoo removal technology, laser tattoo removal, Astanza Trinity, Cryo cooling, Wrentham MA, Franklin MA, Foxboro MA, Norfolk County MA" />
      <meta property="og:title" content="Our Technology | Atomic Tattoo Removal" />
      <meta property="og:description" content="Discover the advanced laser technology we use for safe and effective tattoo removal at Atomic Tattoo Removal." />
      <meta property="og:image" content="https://www.atomictattooremoval.com/assets/technology.png" />
      <meta property="og:url" content="https://www.atomictattooremoval.com/our-technology" />
    </Helmet>
    <div>
    <div
  style={{backgroundColor: '#f0e9d4', margin: '0', padding: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}
>
<Img
  src="/assets/technology.png"
  alt="Our Technology"
  className="technology-image centered-image"
/>
 </div>
 <div  className="our-technology">
      <h1>Our Technology</h1>
      <h2>Powered by Astanza | The Science Behind Superior Tattoo Removal</h2>
      <p>
        At Atomic Tattoo Removal, we believe that removing your tattoo should be as intentional, safe, and precise as getting it. That’s why we’ve invested in state-of-the-art laser technology from Astanza, a global leader in aesthetic laser systems. Whether you're looking to completely remove a tattoo, fade it for a cover-up, or address pigmented skin lesions, our advanced technology gives you the best results with fewer sessions, less discomfort, and better outcomes.
      </p>

      <h2>Why We Chose the Astanza Trinity</h2>
      <p>
        The Astanza Trinity is the gold standard in tattoo removal. This cutting-edge laser system combines three powerful wavelengths—1064 nm, 532 nm, and 694 nm—to break down even the most stubborn tattoo ink, including vibrant colors like blues, purples, and greens that most lasers can’t treat.
      </p>
      <p><strong>What does that mean for you?</strong></p>
      <ul>
        <li>We can safely and effectively treat all ink colors</li>
        <li>Sessions are fast, precise, and tailored to your skin and tattoo type</li>
        <li>Results come quicker, with fewer sessions needed for full removal or fading</li>
      </ul>

      <h2>Enhanced Comfort with Cryo Cooling</h2>
      <p>
        We know that laser treatments can feel intense. That’s why we’ve integrated the Zimmer Cryo 6 into every treatment session. This advanced cryotherapy system directs -30°C cold air to your skin before, during, and after laser application, dramatically reducing discomfort, redness, and the risk of thermal injury.
      </p>
      <p>
        It’s like a built-in numbing system—without needles, numbing creams, or downtime.
      </p>

      <h2>A Smarter Way to Remove Ink</h2>
      <p>
        Our technology doesn’t just remove ink—it works with your body. Here’s how:
      </p>
      <ul>
        <li>Q-switched nanosecond lasers deliver ultra-fast pulses that shatter ink particles into tiny fragments</li>
        <li>Your body’s immune system naturally flushes them out over time, resulting in a clean fade without damaging surrounding skin</li>
        <li>For pigmented lesions, our laser targets excess melanin, gently breaking it up to restore a more even skin tone</li>
      </ul>
      <p>
        Every laser session is customized for your specific tattoo, skin tone, and goals. Safety and effectiveness come first—always.
      </p>

      <h2>Results That Pay Off</h2>
      <p>
        Laser tattoo removal is a journey, but with our advanced tech, the path is shorter, smoother, and more rewarding. Our Trinity laser and Cryo cooling system allow us to:
      </p>
      <ul>
        <li>Remove more ink in less time</li>
        <li>Keep you comfortable every step of the way</li>
        <li>Minimize risks and side effects for all skin types</li>
        <li>Treat pigmented skin lesions safely and effectively</li>
      </ul>

      <h2>Backed by Experts, Built for Results</h2>
      <p>
        Astanza’s technology is based on decades of dermatological research and backed by comprehensive clinical training. We're not just using industry-leading equipment—we're trained, supported, and certified by the very best.
      </p>
      <p>
        At Atomic Tattoo Removal, you’re not just getting a laser—you’re getting a results-driven experience designed around your comfort, safety, and satisfaction.
      </p>

      <h2>Ready to Say Goodbye to Ink?</h2>
      <p>
        Let’s talk about your tattoo removal journey and how we can help you feel confident in your skin again.
      </p>
      <Link to="/book-consultation" style={{ textDecoration: 'none' }}>           
        <Button color="secondary"
          variant="contained"
          onClick={() => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'book_now_click',
              button_location: 'our_technology_page', 
            });
          }}
          sx={{ 
            color: '#f0e9d4', 
            '&:hover': { color:'#ffffff',backgroundColor:'#cb4f2e' } }}
          >
          👉 Book Your Free Consultation
        </Button>  
      </Link> 
    </div>
    </div>
    </>
  );
};

export default OurTechnology;